import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreTabs } from "@slhuicore/tabs";

import { style } from "./assets/tabs.generated-style";

/**
 * (Pseudo)navigation container element.
 * @CustomElement slh-tabs
 *
 * @cssprop --slh-color-neutral-shade-20 - Bottom border color
 *
 * @slot default - Tab items
 * @slot tabs-content - Tab contents
 */
@customElement("slh-tabs")
export default class SlhTabs extends SlhCoreTabs(LitElement) {
  static styles = style;
}
